export function timeoutPromise<T>(promise: Promise<T>, timeout: number): Promise<T> {
  return Promise.race([
    promise,
    new Promise<never>((resolve, reject) => setTimeout(() => reject(new Error('Timeout has occurred')), timeout)),
  ]);
}
